import React from 'react';
import { useNavigate } from 'react-router-dom';
import CreateOrderComponent from "../../../components/Admin/orders/CreateOrderComponent";

const CreateOrderPage = () => {
    const navigate = useNavigate();

    let redirect = () => {
        navigate('/admin/don-dat-hang');
    }

    return <CreateOrderComponent shouldRedirect={ () => redirect() } />;
}

export default CreateOrderPage;